<template>
 <section>
    <social-header title="个人信息保护声明"></social-header>
    <div class="statement-cont">
     <p>保护用户个人信息是汽车之家的一项基本原则。汽车之家将按照本声明及《隐私政策》（链接地址：<span class="blue">http://www.autohome.com.cn/about/falv.htm</span>）的规定收集、使用、储存和分享您的个人信息。本协议对个人信息保护规定的内容与上述《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，以《隐私政策》的内容为准。</p>
     <h5>一、个人信息的收集</h5>
     <p>
         1、我们收集您的个人信息的最终目的是为了向您提供更好的产品、服务，优化并丰富您的用户体验，这些个人信息是能够单独或者与其他信息结合识别您的个人身份的信息，包括：
         <br>①姓名
         <br>②移动电话
         <br>③您在网站的表格上输入的其他信息（电子邮箱、车牌号、住址等）
         <br>④在您上载到网站的内容中包含的任何个人信息
     </p>
     <p>2、以上个人信息均是您自愿提供。您有权拒绝提供，但如果您拒绝提供某些个人信息，您将可能无法使用我们提供的产品、服务，或者可能对您使用产品或服务造成一定的影响。</p>
     <p>3、对于不满 18 岁的用户，须在其法定监护人已经阅读本声明并且许可的情况下，通过网站提交个人信息。</p>
     <h5>二、个人信息的使用和分享</h5>
     <p>您同意，汽车之家可以通过以下方式对个人信息进行使用和分享（包含对于个人信息的存储和处理）：</p>
     <p>我们和关联公司使用；</p>
     <p>我们向相关汽车经销商、厂商及集团分享并由其使用；</p>
     <p>我们及关联公司及相关汽车经销商、厂商为满足您的需求，可能通过您提供的信息与您联系；</p>
     <p>我们及关联公司及相关汽车经销商、厂商可能定期或不定期向您发送有关产品、服务或相关活动的信息，您同意接收上述信息。</p>
     <p>您同意免除上述个人信息的接收和/或使用方在按照本法律声明所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。</p>
     <h5>三、更正或投诉</h5>
    <p>如果您需要查询、修改或更正您的个人信息，或对个人信息保护问题有任何疑问或投诉，您可以拨打电话<span class="red">010-59857593</span>联系我们。</p>
  </div>
  </section>
</template>

<script>
  import SocialHeader from '../../components/social-header.vue'
  export default {
    components: {
      SocialHeader
    },
    name: 'CertificateAgreement'
  }
</script>
<style >
.statement-cont {
    padding: .9375rem;
    line-height: 1.3125rem;
    color: #666;
    font-size: .75rem;
        background: #fff;
}
.statement-cont h5 {
    padding: .5rem 0 .3125rem 0;
    font-size: 1rem;
    color: #333;
}
.statement-cont p {
    padding: .3125rem 0;
}
.red {
    color: #fd5554;
}
.blue {
    color: #4579cd;
}
</style>


// WEBPACK FOOTER //
// src/pages/certificate/agreement.vue